<template>
  <ContactPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactPage from 'chimera/all/components/page/ContactPage.vue'

export default {
  components: {
    ContactPage,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Neem contact met ons op',
      headDescription:
        'Je kunt contact opnemen met Kozijnenvergelijker.nl door het contactformulier in te vullen.',
      path: '/contact-opnemen',
    }
  },
}
</script>
